import { UpperCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Client } from 'src/app/types/identity';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-avatar',
  templateUrl: 'avatar.component.html',
  standalone: true,
  imports: [UpperCasePipe, TranslatePipe],
})
export class AvatarComponent {
  user = input<Pick<Client, 'firstName' | 'lastName' | 'email' | 'avatar' | 'shopifyId'> | undefined>(undefined);
  size = input(40);
  overrideUrl = input<string | undefined>(undefined);
  label = input('');

  readonly avatarFallback = computed(() => {
    const user = this.user();

    if (!user) return this.label();

    if (user && user.firstName && user.lastName) return user.firstName.charAt(0) + user.lastName.charAt(0);
    else if (user.email) return user.email.charAt(0);
    else if (user.shopifyId) return user.shopifyId.slice(0, 2);

    return '';
  });
}
